// Web haptic feedback utility. Gracefully no-ops on unsupported devices.
const canVibrate = () =>
  typeof navigator !== "undefined" &&
  typeof navigator.vibrate === "function" &&
  !window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

export const triggerHaptic = (pattern = 10) => {
  try {
    if (canVibrate()) navigator.vibrate(pattern);
  } catch {
    /* ignore */
  }
};

export const haptics = {
  tap: () => triggerHaptic(10),
  select: () => triggerHaptic(15),
  success: () => triggerHaptic([15, 30, 15]),
  error: () => triggerHaptic([30, 50, 30]),
  heavy: () => triggerHaptic([10, 30, 10]),
};

export default haptics;
